import React, { FunctionComponent } from "react";

import "./caption.scss";

export const Do: FunctionComponent = ({ children }) => {
    return (
        <div className="tag-caption-box tag-caption-box--do">
            <div className="tag-caption tag-caption--do">Do</div>
            <div className="tag-caption--do">{children}</div>
        </div>
    );
};

export const Dont: FunctionComponent = ({ children }) => {
    return (
        <div className="tag-caption-box tag-caption-box--dont">
            <div className="tag-caption tag-caption--dont">Don&apos;t</div>
            <div className="tag-caption--dont">{children}</div>
        </div>
    );
};

export const Caution: FunctionComponent = ({ children }) => {
    return (
        <div className="tag-caption-box tag-caption-box--caution">
            <div className="tag-caption tag-caption--caution">Caution</div>
            <div className="tag-caption--caution">{children}</div>
        </div>
    );
};
